(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1640],{

/***/ 91640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content020": function() { return /* binding */ Content020; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47696);
/* harmony import */ var _Content020_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54438);
/* harmony import */ var _Content020_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Content020_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Content020 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var subtitle = (ref1 = payload === null || payload === void 0 ? void 0 : payload.subtitle) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var quote = (ref2 = payload === null || payload === void 0 ? void 0 : payload.quoteText) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var author = (ref3 = payload === null || payload === void 0 ? void 0 : payload.quoteAuthor) !== null && ref3 !== void 0 ? ref3 : "";
    var ref4;
    var position = (ref4 = payload === null || payload === void 0 ? void 0 : payload.quoteAuthorPosition) !== null && ref4 !== void 0 ? ref4 : "";
    var ref5;
    var list = (ref5 = payload === null || payload === void 0 ? void 0 : payload.list) !== null && ref5 !== void 0 ? ref5 : {};
    var ref6;
    var image = (ref6 = payload === null || payload === void 0 ? void 0 : payload.quoteImage) !== null && ref6 !== void 0 ? ref6 : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content020_module_scss__WEBPACK_IMPORTED_MODULE_2___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
            className: (_Content020_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inner),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Heading3 */ .aC, {
                    className: (_Content020_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Content020_module_scss__WEBPACK_IMPORTED_MODULE_2___default().block),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Content020_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Heading6 */ .Cd, {
                                    className: (_Content020_module_scss__WEBPACK_IMPORTED_MODULE_2___default().subtitle),
                                    children: subtitle
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .OrderedList */ .GS, {
                                    items: list,
                                    className: (_Content020_module_scss__WEBPACK_IMPORTED_MODULE_2___default().full),
                                    appearance: "bigger"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Content020_module_scss__WEBPACK_IMPORTED_MODULE_2___default().blockquote),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Blockquote */ .V6, {
                                image: image,
                                author: author,
                                position: position,
                                quote: quote
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content020);


/***/ }),

/***/ 54438:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content020_wrapper__hy1VR","title":"Content020_title__Yq4kE","subtitle":"Content020_subtitle__4LLe8","block":"Content020_block__VTor_","blockquote":"Content020_blockquote__BVqG1","content":"Content020_content__4FIN0","full":"Content020_full__DNYyk"};

/***/ })

}]);